// Accent- and case-insensitive: "remi" matches "Rémi Confection".
const fold = s => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

// Delegated: the input may be rendered after this script runs.
document.addEventListener('keyup', function (event) {
    if (!event.target.matches || !event.target.matches('#brandSearch')) return;

    const query = fold(event.target.value);
    document.querySelectorAll('#brands-list .brand-wrapper').forEach(wrapper => {
        const label = wrapper.querySelector('p');
        const brandName = fold(label ? label.textContent : '');
        wrapper.style.display = brandName.includes(query) ? '' : 'none';
    });
});
